const getPrimaryMembership = (allMemberships) => {
  const membership = allMemberships?.memberships?.find(
    ({ primary_membership__c }) => primary_membership__c,
  )

  if (membership) {
    const {
      membership_status__c: membershipStatus,
      membership_number__c: membershipNumber,
      sfid,
    } = membership
    return { membershipStatus, membershipNumber, sfid }
  }

  return {}
}

export default getPrimaryMembership
